export default "__VITE_ASSET__Dup78w1___"